import {
  AdminCategory,
  AdminSubcategory,
  CategoryTranslation,
  LocalCategory,
  LocaleResponse,
  LocalSubcategory,
  SubcategoryTranslation,
} from '@cdaas/api-clients/dist/product-service-openapi';

export const getLocalCategoryFromAdminCategory = (category: AdminCategory, locale: LocaleResponse): LocalCategory => {
  const { id } = category;
  const name = category.translations?.find(translation => translation.locale_id === locale.id)?.name || category.name;
  const subcategories = category.subcategories?.map(subcategory => getLocalCategoryFromAdminCategory(subcategory, locale)) || [];
  return {
    id,
    name,
    subcategories,
  };
};

export const getInitialLocalCategory = (): LocalCategory => ({
  id: 0,
  name: '',
  subcategories: [],
});

export const getInitialLocalSubcategory = (): LocalSubcategory => ({
  id: 0,
  name: '',
});

export const getInitialAdminCategory = (): AdminCategory => ({
  id: 0,
  name: '',
  subcategories: [],
  translations: [],
});
export const getInitialAdminSubcategory = (): AdminSubcategory => ({
  id: 0,
  name: '',
  translations: [],
});
export const getInitialCategoryTranslation = (locale_id: LocaleResponse['id']): CategoryTranslation => ({
  id: 0,
  name: '',
  locale_id,
});
export const getInitialSubcategoryTranslation = (locale_id: LocaleResponse['id']): SubcategoryTranslation => ({
  id: 0,
  name: '',
  locale_id,
});

export const getInitialLocale = (): LocaleResponse => ({
  id: 0,
  language_tag: '',
  name: '',
  name_in_native_language: '',
});
